/* istanbul ignore file */
export class ViewEventHandler {
	[s: string]: (data) => void;
}

export class ViewEventManager {
	[s: string]: ViewEventHandler;
}

export interface ViewPageDimensions {
	x: number;
	y: number;
	pageNumber: number;
}

export interface MouseProperties {
	x: number;
	y: number;
	width: number;
	widthPerColumn: number;
	col: number;
	height: number;
	heightPerRow: number;
	row: number;
	height2: number;
	cellAt: ViewCellObject;
}

interface ViewCellBase {
	viewCellId: number;
	pageNumber: number;
	x: number;
	y: number;
	contents: any;
}

export interface ViewCellObject extends ViewCellBase {
	height: number;
	width: number;
	pluginTypeId: any;

	// badly named props from @sureview/vue-grid
	h?: number | undefined;
	w?: number | undefined;
	i?: number | undefined;
}

export interface ViewCellDTO extends ViewCellBase {
	viewId: number;
	columnSpan: number;
	rowSpan: number;
	pluginId: string | null;
	defaultContents?: any;
}

export interface ViewObject {
	title: string;
	viewId: number;
	public: boolean;
	cells: ViewCellObject[];
	groupId: number | null;
	ownerUserId: number;
	dateLoaded?: string;
	pages?: ViewPage[];
	locked: boolean;
	hasUserGroups: boolean;
}

export interface PageKeeperResponse {
	pageNumber: number,
	responseCount: number
}

interface ViewPageBase {
	viewId: number;
	pageNumber: number;
	columns: number;
	rows: number;
}

export interface ViewPage extends ViewPageBase {
	cells: ViewCellObject[];
}

export interface ViewPageDTO extends ViewPageBase {
	cells: ViewCellDTO[];
}

export interface ViewSaveDTO {
	pages: ViewPageDTO[];
	viewId: number;
	title: string;
	ownerUserId: number | null;
	isPublic: boolean;
	groupId: number | null;
	hasUserGroups: boolean;
}

export interface ViewReadDTO extends ViewSaveDTO {
	dynamicTypeId: number | null;
	requiresProcessingPermission: boolean;
	alwaysRecord: boolean;
	comment: string;
	sessionId: string;
	sharedSession: boolean | null;
	canShare: boolean;
	canSetContent: boolean | null;
	canEdit: boolean | null;
	dateLoaded: string | null;
}

export enum ViewMode {
	None,
	Edit,
	Add
}

export interface ViewsState {
	pluginTypes: any[];
	views: ViewObject[];
	userViews: ViewObject[];
	selectedView: ViewObject;
	selectedViewPageNumber: number;
	selectedTileType: any;
	viewMode: ViewMode;
	sideBarExtended: boolean;
	sideBarPinned: boolean;
	latestEvent: any;
	cellContents: any;
	groupsList: any[];
	eventHandlers: ViewEventManager;
	viewSessionId: string;
}

export interface UpdatedViewCellData {
	viewId: number;
	viewCellId: number;
	contents: any;
	defaultContents: any;
}

export interface CellPosition {
	width: number;
	height: number;
	x: number;
	y: number;
}

export interface ICamera {
	deviceID: number;
	deviceTypeID: number;
	groupId: number;
	settingsMeta: string;
	title: string;
}

export interface FeatureTreeNode {
	children?: FeatureTreeNode[];
	description?: string | null;
	enabled: boolean;
	isDefault?: boolean;
	isRelease?: string;
	name: string;
	supportLink?: string;
	expanded?: boolean;
}
